import { BehaviorSubject, Observable } from 'rxjs';

export class Store<T> {
    private _state$: Observable<T>;
    private _state: BehaviorSubject<T>;

    protected constructor(initialState: T) {
        this._state = new BehaviorSubject(initialState);
        this._state$ = this._state.asObservable();
    }

    get state(): T {
        return this._state.getValue();
    }

    get state$(): Observable<T> {
        return this._state$;
    }

    setState(nextState: T): void {
        this._state.next(nextState);
    }

}
